import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import baseURL from "../../../../Url/NodeBaseURL";
import { Button, Row, Col } from "react-bootstrap";
import InputField from "../../../Pages/InputField/InputField";
import useProductHandlers from "../SalesForm/hooks/useProductHandlers";

const SubmissionView = () => {
  const { metaltypeOptions } = useProductHandlers();
  const { productId, vendorId, order_number } = useParams();
  const navigate = useNavigate();
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const [payments, setPayments] = useState([
    { payment_mode: "", paid_amount: "" },
  ]);
  const [remarks, setRemarks] = useState("");
  const [isSampleReceived, setIsSampleReceived] = useState(false);
  const [showPayAsMetal, setShowPayAsMetal] = useState(false);
  const [metalForm, setMetalForm] = useState({
    metals: [
      {
        metal_type: "",
        purity: "",
        weight: "",
        // mc_type: "",
        // mc_charges: "",
        rate: "",
      },
    ],
  });
  const [hasSample, setHasSample] = useState(false);

  const [currentRates, setCurrentRates] = useState({
    rate_16crt: "",
    rate_18crt: "",
    rate_22crt: "",
    rate_24crt: "",
    silver_rate: "",
  });

  useEffect(() => {
    const fetchCurrentRates = async () => {
      try {
        const response = await axios.get(`${baseURL}/get/current-rates`);
        if (response.data) {
          setCurrentRates({
            rate_16crt: response.data.rate_16crt || "",
            rate_18crt: response.data.rate_18crt || "",
            rate_22crt: response.data.rate_22crt || "",
            rate_24crt: response.data.rate_24crt || "",
            silver_rate: response.data.silver_rate || "",
          });
        }
      } catch (error) {
        console.error("Error fetching current rates:", error);
      }
    };

    fetchCurrentRates();
  }, []);
  const calculateMetalRate = (metal, currentRates) => {
    let price = 0;
    let finalRate = 0;
    let purity = Number(metal.purity?.toString().replace("%", "").trim() || 0);

    if (metal.metal_type.toLowerCase() === "silver") {
      price =
        (((Number(currentRates.silver_rate) || 0) * purity) / 100) *
        (Number(metal.weight) || 0);
    } else {
      price =
        (((Number(currentRates.rate_24crt) || 0) * purity) / 100) *
        (Number(metal.weight) || 0);
    }

    // let makingCharges = 0;
    // if (metal.mc_type === "MC %") {
    //   makingCharges = ((Number(metal.mc_charges) || 0) * price) / 100;
    // } else if (metal.mc_type === "MC / Gram") {
    //   makingCharges =
    //     (Number(metal.mc_charges) || 0) * (Number(metal.weight) || 0);
    // }

    // finalRate = price + makingCharges;
    finalRate = price;
    return finalRate.toFixed(2);
  };

  const handleMetalFormChange = (index, field, value) => {
    setMetalForm((prev) => {
      const updatedMetals = [...prev.metals];
      updatedMetals[index][field] = value;
      updatedMetals[index].rate = calculateMetalRate(
        updatedMetals[index],
        currentRates
      );
      return { ...prev, metals: updatedMetals };
    });
  };

  const updateRatesForMetals = () => {
    setMetalForm((prev) => {
      const updatedMetals = prev.metals.map((metal) => ({
        ...metal,
        rate: calculateMetalRate(metal, currentRates),
      }));
      return { ...prev, metals: updatedMetals };
    });
  };

  useEffect(() => {
    if (metalForm.metals.length > 0) {
      updateRatesForMetals();
    }
  }, [currentRates]);
  useEffect(() => {
    if (metalForm.metal_type && metalForm.purity && metalForm.weight) {
      const calculatedRate = calculateMetalRate(metalForm, currentRates);
      setMetalForm((prev) => ({
        ...prev,
        rate: calculatedRate,
      }));
    }
  }, [
    metalForm.metal_type,
    metalForm.purity,
    metalForm.weight,
    // metalForm.mc_type,
    // metalForm.mc_charges,
    currentRates,
  ]);

  const headTheme = { "--bs-table-bg": "#a36e29", "--bs-table-color": "#fff" };
  let totalRate = 0;

  const handleSubmit = async () => {
    if (!product) {
      alert("Product data not loaded yet.");
      return;
    }
    const totalMetalrate = metalForm.metals.reduce(
      (sum, m) => sum + (Number(m.rate) || 0),
      0
    );
    console.log("=== Submit Debug ===");
    console.log("metals:", metalForm.metals);
    console.log("calculated totalRate:", totalMetalrate);

    const netPayable = (
      (Number(product.submission_actual_price) || 0) -
      (Number(product.assigned_advance_amt) || 0) -
      (Number(totalRate) || 0)
    ).toFixed(2);

    const totalPaid = (
      payments.reduce((sum, p) => sum + Number(p.paid_amount || 0), 0) +
      totalMetalrate
    ).toFixed(2);

    if (Number(totalPaid).toFixed(2) !== Number(netPayable).toFixed(2)) {
      alert(
        `Total paid (₹${totalPaid}) must equal Net Payable (₹${netPayable})`
      );
      return;
    }

    const allValid = payments.every((p) => p.payment_mode && p.paid_amount);
    if (!allValid) {
      alert("Please fill all payment modes and amounts.");
      return;
    }

    try {
      await axios.patch(
        `${baseURL}/vendor/${vendorId}/submissions/${productId}`,
        {
          status: "selected",
          payments: payments,
          metals: metalForm.metals,
        }
      );

      alert("Marked as received.");
      navigate(`/orderstable/${order_number}`);
    } catch (error) {
      console.error("Error marking as received:", error);
      alert("Failed to mark as received.");
    }
  };

  useEffect(() => {
    const fetchSubmission = async () => {
      try {
        const res = await axios.get(
          `${baseURL}/vendor/${vendorId}/assignments/${productId}`
        );
        const all = res.data[0];
        setProduct(all);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching submission:", error);
        setLoading(false);
      }
    };

    fetchSubmission();
  }, [productId]);

  return (
    <div className="main-container mt-3">
      <div className="payments-table-container">
        <Row className="mb-3">
          <Col className="d-flex justify-content-between align-items-center">
            <h4>Submission Details</h4>
            <Button
              className="create_but"
              onClick={() => navigate(-1)}
              style={{ backgroundColor: "#a36e29", borderColor: "#a36e29" }}
              size="sm"
            >
              ← Back
            </Button>
          </Col>
        </Row>
        {loading ? (
          <p>Loading...</p>
        ) : (
          <>
            <div style={{ overflowX: "auto" }}>
              <table className="table table-bordered border-dark-subtle">
                <tbody>
                  <tr>
                    <th>Bar Code</th>
                    <td>{product.code}</td>
                    <th>Product Name</th>
                    <td>{product.product_name}</td>
                    <th>Metal Type</th>
                    <td>{product.metal_type}</td>
                    <th>Purity</th>
                    <td>{product.purity}</td>
                  </tr>
                  <tr>
                    <th>Gross Wt</th>
                    <td>{product.gross_weight}</td>
                    <th>Stone Wt</th>
                    <td>{product.stone_weight}</td>
                    <th>W.Wt</th>
                    <td>{product.wastage_weight}</td>
                    <th>Total Wt</th>
                    <td>{product.total_weight_av}</td>
                  </tr>
                  <tr>
                    <th>Size</th>
                    <td colSpan="7">{product.size}</td>
                  </tr>
                  <tr>
                    <th colSpan="9" className="text-center">
                      Assigned Metals
                    </th>
                  </tr>
                  <tr>
                    <td colSpan="9">
                      {(() => {
                        let metals = [];

                        try {
                          let parsed = JSON.parse(
                            product.assigned_metals || "[]"
                          );
                          metals =
                            typeof parsed === "string"
                              ? JSON.parse(parsed)
                              : parsed;
                        } catch (err) {
                          console.error("Invalid assigned_metals JSON:", err);
                        }
                        totalRate = Array.isArray(metals)
                          ? metals.reduce(
                              (sum, m) => sum + (Number(m.rate) || 0),
                              0
                            )
                          : 0;

                        if (!Array.isArray(metals) || metals.length === 0) {
                          return <div>No assigned metals</div>;
                        }

                        return (
                          <table className="table table-bordered border-dark-subtle mt-2">
                            <thead style={headTheme}>
                              <tr>
                                <th>Metal Type</th>
                                <th>Purity</th>
                                <th>Weight</th>
                                <th>MC Type</th>
                                <th>MC</th>
                                <th>Total Cost</th>
                                <th>Additional Description</th>
                                <th>Additional Images/Videos</th>
                              </tr>
                            </thead>
                            <tbody>
                              {metals.map((m, idx) => (
                                <tr key={idx}>
                                  <td>{m.metal_type}</td>
                                  <td>
                                    {m.metal_purity === "Manual"
                                      ? `Manual - ${m.custom_purity || ""}%`
                                      : m.metal_purity}
                                  </td>
                                  <td>{m.metal_weight}</td>
                                  <td>{product.assigned_hm_type}</td>
                                  <td>{product.assigned_hm_charges}</td>
                                  <td>{m.rate}</td>
                                  <td>{m.additional_description}</td>
                                  <td>
                                    <div
                                      style={{
                                        display: "flex",
                                        flexWrap: "wrap",
                                        gap: "8px",
                                        marginTop: "4px",
                                      }}
                                    >
                                      {(() => {
                                        let mediaItems = [];
                                        try {
                                          mediaItems = Array.isArray(
                                            m.additional_images
                                          )
                                            ? m.additional_images
                                            : JSON.parse(
                                                m.additional_images || "[]"
                                              );
                                        } catch (err) {
                                          console.error(
                                            "Invalid image JSON:",
                                            err
                                          );
                                        }

                                        return mediaItems.map((item, index) => {
                                          const src =
                                            typeof item === "string"
                                              ? item
                                              : item.src;
                                          const type = item?.type || "";

                                          if (type.startsWith("video/")) {
                                            return (
                                              <video
                                                key={index}
                                                src={src}
                                                width="100"
                                                height="80"
                                                controls
                                                style={{
                                                  objectFit: "cover",
                                                  border: "1px solid #ccc",
                                                  borderRadius: "4px",
                                                }}
                                              />
                                            );
                                          }

                                          return (
                                            <img
                                              key={index}
                                              src={src}
                                              alt={`media-${index}`}
                                              width="100"
                                              height="80"
                                              style={{
                                                objectFit: "cover",
                                                border: "1px solid #ccc",
                                                borderRadius: "4px",
                                              }}
                                            />
                                          );
                                        });
                                      })()}
                                    </div>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        );
                      })()}
                    </td>
                  </tr>

                  {/* Samples Section */}
                  <tr>
                    <th colSpan="9" className="text-center">
                      Samples
                    </th>
                  </tr>
                  <tr>
                    <td colSpan="9">
                      {(() => {
                        let samples = [];

                        try {
                          let parsed = product.assigned_samples;
                          if (typeof parsed === "string")
                            parsed = JSON.parse(parsed);
                          if (typeof parsed === "string")
                            parsed = JSON.parse(parsed);
                          samples = Array.isArray(parsed) ? parsed : [];
                        } catch (err) {
                          console.error("Invalid assigned_samples JSON:", err);
                        }

                        if (!Array.isArray(samples) || samples.length === 0) {
                          return <div>No samples</div>;
                        }
                        setHasSample(
                          samples.every((s) => Number(s.sample_wt) > 0)
                        );

                        return (
                          <table className="table table-bordered border-dark-subtle mt-2">
                            <thead style={headTheme}>
                              <tr>
                                <th>Metal Type</th>
                                <th>Purity</th>
                                <th>Weight</th>
                                <th>Description</th>
                                <th>Photo</th>
                              </tr>
                            </thead>
                            <tbody>
                              {samples.map((sample, index) => (
                                <tr key={index}>
                                  <td>{sample.sample_metaltype || "—"}</td>
                                  <td>
                                    {sample.sample_purity === "Manual"
                                      ? `Manual - ${
                                          sample.sample_custom_purity || ""
                                        }%`
                                      : sample.sample_purity}
                                  </td>
                                  <td>{sample.sample_wt || "—"}</td>
                                  <td>{sample.sample_des || "—"}</td>
                                  <td>
                                    {Array.isArray(sample.sample_photo) &&
                                    sample.sample_photo.length > 0
                                      ? sample.sample_photo.map((img, i) => (
                                          <img
                                            key={i}
                                            src={img}
                                            alt={`sample-${index}-${i}`}
                                            width="100"
                                            height="80"
                                            style={{
                                              objectFit: "cover",
                                              border: "1px solid #ccc",
                                              borderRadius: "4px",
                                              marginRight: "5px",
                                            }}
                                          />
                                        ))
                                      : "No Image"}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        );
                      })()}
                    </td>
                  </tr>
                  <tr>
                    <th>Advance Amount</th>
                    <td colSpan="3">₹ {product.assigned_advance_amt}</td>
                    <th>Advance Payment Mode</th>
                    <td colSpan="3">{product.assigned_payment_mode}</td>
                  </tr>
                  <tr>
                    <th>Actual Gross Weight</th>
                    <td colSpan="3">
                      {product.submission_actual_gross_weight}
                    </td>
                    <th>Actual Wastage Weight</th>
                    <td colSpan="3">
                      {product.submission_actual_wastage_weight}
                    </td>
                  </tr>
                  <tr>
                    <th>Actual Price</th>
                    <td colSpan="7">₹ {product.submission_actual_price}</td>
                  </tr>
                  <tr>
                    <th>Submitted Images</th>
                    <td colSpan="7">
                      <div
                        style={{
                          display: "flex",
                          flexWrap: "wrap",
                          gap: "8px",
                          marginTop: "8px",
                        }}
                      >
                        {(() => {
                          let mediaItems = [];

                          try {
                            const firstParse = JSON.parse(
                              product.submission_images || "[]"
                            );
                            mediaItems = Array.isArray(firstParse)
                              ? firstParse
                              : JSON.parse(firstParse);
                          } catch (err) {
                            console.error(
                              "Invalid submission_images JSON (double parse):",
                              err
                            );
                          }

                          return mediaItems.map((item, index) => {
                            const isVideo = item.type?.startsWith("video");

                            return isVideo ? (
                              <video
                                key={index}
                                src={item.src}
                                width="100"
                                height="80"
                                controls
                                style={{
                                  objectFit: "cover",
                                  border: "1px solid #ccc",
                                  borderRadius: "4px",
                                }}
                              />
                            ) : (
                              <img
                                key={index}
                                src={item.src}
                                alt={`submitted-${index}`}
                                width="100"
                                height="80"
                                style={{
                                  objectFit: "cover",
                                  border: "1px solid #ccc",
                                  borderRadius: "4px",
                                }}
                              />
                            );
                          });
                        })()}
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <th>Net Payable Amount</th>
                    <td colSpan="7">
                      ₹{" "}
                      {(
                        (Number(product.submission_actual_price) || 0) -
                        (Number(product.assigned_advance_amt) || 0) -
                        (Number(totalRate) || 0)
                      ).toFixed(2)}
                    </td>
                  </tr>
                  <tr>
                    <td colSpan="8" className="text-start">
                      <button
                        className="btn btn-sm btn-primary"
                        onClick={() => setShowPayAsMetal((prev) => !prev)}
                      >
                        Pay Using Metal
                      </button>
                    </td>
                  </tr>
                  {showPayAsMetal &&
                    metalForm.metals.map((metal, index) => (
                      <tr key={index}>
                        <td colSpan="8">
                          <div className="p-4 border rounded bg-light">
                            <h5>Pay Using Metal</h5>
                            <Row>
                              <Col md={3}>
                                <label>Metal Type</label>
                                <InputField
                                  label=""
                                  name="metal_type"
                                  value={metal.metal_type}
                                  onChange={(e) =>
                                    handleMetalFormChange(
                                      index,
                                      "metal_type",
                                      e.target.value
                                    )
                                  }
                                  type="select"
                                  options={metaltypeOptions}
                                />
                              </Col>

                              <Col md={2}>
                                <label>Purity (%)</label>
                                <InputField
                                  label=""
                                  name="purity"
                                  value={metal.purity}
                                  onChange={(e) =>
                                    handleMetalFormChange(
                                      index,
                                      "purity",
                                      e.target.value
                                    )
                                  }
                                  type="number"
                                />
                              </Col>

                              <Col md={2}>
                                <label>Weight (g)</label>
                                <InputField
                                  label=""
                                  name="weight"
                                  value={metal.weight}
                                  onChange={(e) =>
                                    handleMetalFormChange(
                                      index,
                                      "weight",
                                      e.target.value
                                    )
                                  }
                                  type="number"
                                />
                              </Col>
                              <Col md={3}>
                                <label>Rate</label>
                                <InputField
                                  label=""
                                  name="rate"
                                  value={metal.rate}
                                  disabled
                                />
                              </Col>
                            </Row>
                          </div>
                        </td>
                      </tr>
                    ))}

                  {payments.map((payment, index) => (
                    <tr key={index}>
                      <th>Payment Mode</th>
                      <td colSpan="3">
                        <select
                          className="form-select"
                          value={payment.payment_mode}
                          onChange={(e) => {
                            const updated = [...payments];
                            updated[index].payment_mode = e.target.value;
                            setPayments(updated);
                          }}
                        >
                          <option value="">Select</option>
                          <option value="Cash">Cash</option>
                          <option value="Online">Online</option>
                          <option value="Bank Transfer">Bank Transfer</option>
                          <option value="Cheque">Cheque</option>
                          <option value="Card">Card</option>
                        </select>
                      </td>
                      <th>
                        {index === 0 ? "Amount Paid" : "Additional Payment"}
                      </th>
                      <td colSpan="3">
                        <input
                          type="number"
                          className="form-control"
                          placeholder="Enter Amount"
                          value={payment.paid_amount}
                          onChange={(e) => {
                            const updated = [...payments];
                            updated[index].paid_amount = e.target.value;
                            setPayments(updated);
                          }}
                        />
                      </td>
                    </tr>
                  ))}
                  <tr>
                    <td colSpan="8">
                      <button
                        className="btn btn-sm btn-outline-primary"
                        onClick={() =>
                          setPayments([
                            ...payments,
                            { payment_mode: "", paid_amount: "" },
                          ])
                        }
                      >
                        + Add Payment
                      </button>
                    </td>
                  </tr>

                  {/* {Number(product.sample_wt) !== 0 && (
                    <tr>
                      <th>Sample Received</th>
                      <td colSpan="7">
                        <div className="form-check">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id="sampleReceivedCheckbox"
                            checked={true} // or false, or controlled from props/state
                            readOnly // or handle with onChange if needed
                          />
                          <label
                            className="form-check-label ms-2"
                            htmlFor="sampleReceivedCheckbox"
                          >
                            Received Sample
                          </label>
                        </div>
                      </td>
                    </tr>
                  )} */}
                </tbody>
              </table>
              {/* {Number(product.sample_wt) !== 0 && (
                <div className="my-3">
                  <div className="form-check d-flex align-items-center">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id="sampleReceivedCheckbox"
                      checked={isSampleReceived}
                      onChange={(e) => setIsSampleReceived(e.target.checked)}
                      style={{ marginTop: 0 }} // optional, ensures vertical alignment
                    />
                    <label
                      className="form-check-label ms-2"
                      htmlFor="sampleReceivedCheckbox"
                    >
                      Received Sample
                    </label>
                  </div>
                </div>
              )} */}

              <div className="my-3">
                <div className="form-check d-flex align-items-center">
                  {hasSample ? (
                    <div>
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="sampleReceivedCheckbox"
                        checked={isSampleReceived}
                        onChange={(e) => setIsSampleReceived(e.target.checked)}
                        style={{ marginTop: 0 }}
                      />
                      <label
                        className="form-check-label ms-2"
                        htmlFor="sampleReceivedCheckbox"
                      >
                        Received Sample
                      </label>
                    </div>
                  ) : (
                    <p className="text-muted my-3">No sample was given</p>
                  )}
                </div>
              </div>

              <div className="text-center mt-4">
                <button
                  className="btn btn-primary"
                  style={{
                    backgroundColor: "#a36e29",
                    borderColor: "#a36e29",
                    padding: "8px 24px",
                    fontWeight: "bold",
                  }}
                  onClick={handleSubmit}
                >
                  Submit
                </button>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default SubmissionView;
